/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkboardEmailTemplate = {
  readonly id?: number;
  readonly kind?: WorkboardEmailTemplate.kind;
  name: string;
  email_subject: string;
  introduction: string;
  readonly created_by?: number | null;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace WorkboardEmailTemplate {
  export enum kind {
    ONBOARDING = 'onboarding',
    FINAL_REPORT = 'final_report',
  }
}
